import React from 'react';
import {
    Eye as EyeIcon,
    EyeOff as EyeOffIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
    MinusCircle as MinusCircleIcon,
    Server as ServerIcon,
    Play as VerifyIcon,
    Send as SendIcon,
    BookOpen as OpenIcon
} from 'react-feather';
import {Button} from "@material-ui/core";
import FlagIcon from "../FlagIcon";
import IconButton from "@material-ui/core/IconButton";
import SvgIcon from "@material-ui/core/SvgIcon";
import {ArrowRightIcon} from "@material-ui/pickers/_shared/icons/ArrowRightIcon";
import {formatDateOnly, formatDateTime, formatSeconds} from "../../utils/Formatter";
import Alert from "@material-ui/lab/Alert";
import InInIcon from "../../assets/icons/in_in_icon.svg";
import OutOutIcon from "../../assets/icons/out_out_icon.svg";
import NoInIcon from "../../assets/icons/no_in_icon.svg";
import UndefinedDirectionIcon from "../../assets/icons/undef_icon.svg";
import StaticClassifierRepository from "../../repositories/StaticClassifierRepository";

const staticClassifierRepository = new StaticClassifierRepository();

export const ActionButtonTypes = { EDIT: "EDIT", DELETE: "DELETE", LOGS: "LOGS", VERIFY: "VERIFY", EXPORT: "EXPORT", VIEW: "VIEW" };

const selectTemplateForButtonType = (type) => {
    switch (type) {
        case ActionButtonTypes.EDIT:
            return <EditIcon color="green" />;
        case ActionButtonTypes.DELETE:
            return <DeleteIcon color="red" />;
        case ActionButtonTypes.LOGS:
            return <ServerIcon />;
        case ActionButtonTypes.VERIFY:
            return <VerifyIcon />;
        case ActionButtonTypes.EXPORT:
            return <SendIcon />;
        case ActionButtonTypes.VIEW:
            return <OpenIcon />;
    }
}

export const BooleanGridColumnType = {
  type: 'string',
  width: 130,
  renderCell: ({ value }) => {
      return value ? <EyeIcon color="green" /> : <EyeOffIcon color="grey" /> ;
  }
};

export const ActionsGridColumnType = {
    type: 'string',
    width: 200,
    sortable: false
};

export const ActionButtons = (buttons) => {

    const templates = buttons.map(({type, ...rest}) => {
        return { type: type, button: selectTemplateForButtonType(type), ...rest };
    });

    return Object.assign(ActionsGridColumnType, {
        renderCell: (cell) => {
            return <div>{templates.map(({onClick, button, type, visibilityCondition, ...rest}, i) => {
                return (!visibilityCondition || visibilityCondition && visibilityCondition(cell.row)) ? (
                 <ActionButton key={i} onClick={onClick} content={button} row={cell.row} {...rest}  />
                ) : ''

            })}</div>
      }
    });
};

export const NumberPlateColumnType = {
    width: 120,
    sortable: false,
    renderCell: (cell) => {
        return <span>{cell.value}{cell.row.NumberPlateOrigin && <FlagIcon code={cell.row.NumberPlateOrigin.toLowerCase()} size={"lg"}/>}</span>;
    }
};

export const EventDateColumnType = {
    sortable: false,
    width: 170,
    renderCell: ({value}) => {
        if (!value) {
            return '';
        }
        return formatDateTime(value)
    }
};

export const EventDateOnlyColumnType = {
    sortable: false,
    width: 180,
    renderCell: ({value}) => {
        if (!value) {
            return '';
        }
        return formatDateOnly(value)
    }
};

export const ArrayColumnType = {
    sortable: false,
    width: 180,
    renderCell: ({value}) => {
        if (!value) {
            return '';
        }
        return value.join(', ');
    }
};

export const ParkingEventIsCheckedColumnType = () => {

    return {
        width: 140,
        sortable: false,
        renderCell: ({value}) => {
            return staticClassifierRepository.getVerificationStatusNameById(value);
        }
    }
};

export const NumberPlateImageUrlColumnType = {
   width: 200,
    sortable: false,
    renderCell: ({ value }) => {
        return value ? <img src={value} style={{maxHeight: 250, maxWidth: 120}} /> : '';
    }
};

export const DurationColumnType = {
    width: 200,
    sortable: false,
    renderCell: ({ value, row }) => {
        const renderValue = value > 0 ? formatSeconds(value) : '';
        if (row.Suspicious) {
            return (<Alert severity="error">{renderValue}</Alert>);
        }
        return renderValue;
    }
};

export const JoinedColumnType = {
    width: 200,
    sortable: false,
    renderCell: (cell) => {
        return <div>{cell.value.join(",")}</div>
    }
};

export const ParkingEventSuspiciousColumnType = {
    width: 100,
    sortable: false,
    renderCell: ({ value, row }) => {
        if (row.Suspicious) {

            switch (row.Suspicious) {
                case 10:
                    return ( <img src={UndefinedDirectionIcon} />);
                case 20:
                    return (<img src={InInIcon} />);
                case 21:
                    return (<img src={OutOutIcon} />);
                case 22:
                    return (<img src={NoInIcon} />);
                default:
                    return (<MinusCircleIcon color="red" />);
            }
        }
        return '';
    }
};

export const buildActionButton = (type, title, handler, visibilityCondition) => {
    return { type: type, onClick: handler, title: title, visibilityCondition: visibilityCondition };
}

export const buildViewDetailsButton = (handler) => {

    return Object.assign(ActionsGridColumnType, {
        renderCell: (cell) => {
            return (
             <div>
                  <IconButton onClick={e => handler(cell.row)}>
                    <SvgIcon fontSize="small">
                      <ArrowRightIcon />
                    </SvgIcon>
                  </IconButton>
             </div>)
      }
    });
}

export const ParkingEventLinkColumnType = ({onClick}) => {

    return {
        width: 80,
        sortable: false,
        renderCell: (cell) => {
            return cell.value && <a href={"#"} onClick={e => onClick(cell.row)}>{cell.value}</a>;
        }
    }
};

export const ActionButton = ({onClick, content, row, ...rest}) => {
    return (<Button onClick={e => {
                    onClick(row);
                } } {...rest}>{content}</Button>);
}